export default __webpack_public_path__ + "static/media/bg-img06.78f77637.jpg";